export default import.meta.ROLLDOWN_FILE_URL_pX6aMxLBX$PROv7I4jKTGw